// This function allow to reference async chunks
__webpack_require__.u = function(chunkId) {
	// return url for filenames based on template
	return "js/" + {"12":"profiler","777":"recorder"}[chunkId] + "-" + {"12":"e66000ab924951d93e3a","777":"bc951d13a480e32b45a1"}[chunkId] + ".chunk.js";
};